// import external modules
import React, { useEffect, useState } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import { toastr } from "react-redux-toastr";
import Router from "./router";
import registerServiceWorker from '../registerServiceWorker';
import Spinner from "../components/spinner/spinner";
import { configSocket } from "../services/socket";

function App() {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const [worker, setWorker] = useState(null);
  const [loadingSocket, setLoadingSocket] = useState(true);

  function onServiceWorkerUpdate(worker) {
    setWorker(worker);
    setNewVersionAvailable(true);
  }

  function updateServiceWorker() {
    if (worker) {
      worker.postMessage({ action: 'skipWaiting' });
    }
    setNewVersionAvailable(false);
  }

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      registerServiceWorker({ updateReady: onServiceWorkerUpdate });
    }
  }, []);

  useEffect(() => {
    if (newVersionAvailable) {
      toastr.info(
        'Uma nova versão da aplicação está disponível!',
        'Clique aqui para atualizá-la agora.',
        {
          timeOut: 0,
          onToastrClick: updateServiceWorker
        }
      )
    }
  }, [newVersionAvailable]);

  useEffect(() => {
    configSocket()
      .then(() => setLoadingSocket(false))
      .catch(() => setLoadingSocket(false))
  }, []);

  useEffect(() => {
    return () => {
      window.fcWidget.off('user:created');
    }
  }, []);

  return !loadingSocket ? <Router /> : <Spinner />;
}

export default App;
